import React, { createContext, useContext, useState, ReactNode } from "react";
import Modal from "../components/Modal";

interface ModalContextType {
    modalContent: ReactNode | null;
    openModal: (content: ReactNode) => void;
    closeModal: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

// Hook personnalisé pour utiliser le contexte
export const useModal = (): ModalContextType => {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error("useModal must be used within a ModalProvider");
    }
    return context;
};

export const ModalProvider = ({ children }: { children: ReactNode }) => {
    const [modalContent, setModalContent] = useState<ReactNode | null>(null);
    const openModal = (content: ReactNode) => setModalContent(content);
    const closeModal = () => setModalContent(null);

    return (
        <ModalContext.Provider value={{ openModal, closeModal, modalContent }}>
            {children}
            {modalContent && (
                <Modal>
                    {modalContent}
                </Modal>
            )}
        </ModalContext.Provider>
    );
};